import type { ReactElement } from 'react';

import { IconButton, Tooltip } from '@rango-dev/whale';
import { LogOut as LogOutIcon } from 'lucide-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '../../../hooks/reduxHooks';
import { SimpleNotification } from '../../SimpleNotification';
import { LogOutModal } from '../LogOutModal';

const LOGOUT_ICON_SIZE = 18;

export function LogOut(): ReactElement {
  const { loading } = useAppSelector((state) => state.profile.profileSummary.private);
  const { t } = useTranslation();

  const [showLogOutModal, setShowLogOutModal] = useState(false);
  const [showLogOutError, setShowLogOutError] = useState(false);

  return (
    <>
      <SimpleNotification
        message={t('An error occurred during logout. Please try again.')}
        open={showLogOutError}
        setOpen={setShowLogOutError}
        severity="error"
      />
      <LogOutModal open={showLogOutModal} onClose={() => setShowLogOutModal(false)} />
      <Tooltip content={t('Logout')} side="bottom" sideOffset={14}>
        <IconButton
          id="profile-card-logout"
          variant="outline"
          color="cyan"
          size="2"
          radius="full"
          disabled={loading}
          onClick={() => setShowLogOutModal(true)}
          aria-label={t('Logout')}>
          <LogOutIcon size={LOGOUT_ICON_SIZE} />
        </IconButton>
      </Tooltip>
    </>
  );
}
